export default __webpack_public_path__ + "static/media/urinari-shadow.f9159424.svg";